import script from "./find-property-results.vue?vue&type=script&setup=true&lang=ts"
export * from "./find-property-results.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__